const INLINE_ZOOM_SCALE = 3;
const DRAG_THRESHOLD = 6;
const imageState = new WeakMap();
let activePanImage = null;

function getState(image) {
  if (!imageState.has(image)) {
    imageState.set(image, {
      tx: 0,
      ty: 0,
      startX: 0,
      startY: 0,
      startTx: 0,
      startTy: 0,
      panning: false,
      moved: false,
      movedRecently: false,
    });
  }
  return imageState.get(image);
}

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function getBounds(image) {
  const container = image.closest('.product-media-container.media-type-image');
  if (!container) return null;
  const containerWidth = container.clientWidth;
  const containerHeight = container.clientHeight;
  const scaledWidth = containerWidth * INLINE_ZOOM_SCALE;
  const scaledHeight = containerHeight * INLINE_ZOOM_SCALE;
  return {
    minX: containerWidth - scaledWidth,
    maxX: 0,
    minY: containerHeight - scaledHeight,
    maxY: 0,
  };
}

function applyTransform(image) {
  const state = getState(image);
  image.style.transform = `translate(${state.tx}px, ${state.ty}px) scale(${INLINE_ZOOM_SCALE})`;
}

function resetImageZoom(image) {
  const container = image.closest('.product-media-container.media-type-image');
  if (!container) return;
  const state = getState(image);
  state.tx = 0;
  state.ty = 0;
  state.panning = false;
  state.moved = false;
  state.movedRecently = false;
  container.classList.remove('is-inline-zoomed', 'is-panning');
  image.style.transform = '';
}

function clearInlineZoom(galleryRoot) {
  galleryRoot.querySelectorAll('.image-magnify-click').forEach((image) => {
    resetImageZoom(image);
  });
}

function zoomAtPoint(image, pointerX, pointerY) {
  const container = image.closest('.product-media-container.media-type-image');
  if (!container) return;

  const rect = container.getBoundingClientRect();
  const clickX = pointerX - rect.left;
  const clickY = pointerY - rect.top;
  const state = getState(image);
  const bounds = getBounds(image);
  if (!bounds) return;

  state.tx = clamp(rect.width / 2 - clickX * INLINE_ZOOM_SCALE, bounds.minX, bounds.maxX);
  state.ty = clamp(rect.height / 2 - clickY * INLINE_ZOOM_SCALE, bounds.minY, bounds.maxY);
  container.classList.add('is-inline-zoomed');
  applyTransform(image);
}

document.addEventListener('click', (event) => {
  const image = event.target.closest('.image-magnify-click');
  if (!image) return;

  const container = image.closest('.product-media-container.media-type-image');
  if (!container) return;

  const state = getState(image);
  if (state.movedRecently) {
    state.movedRecently = false;
    return;
  }

  const galleryRoot = image.closest('media-gallery') || document;
  if (container.classList.contains('is-inline-zoomed')) {
    resetImageZoom(image);
    return;
  }

  clearInlineZoom(galleryRoot);
  zoomAtPoint(image, event.clientX, event.clientY);
});

document.addEventListener('pointerdown', (event) => {
  const image = event.target.closest('.image-magnify-click');
  if (!image) return;
  const container = image.closest('.product-media-container.media-type-image');
  if (!container || !container.classList.contains('is-inline-zoomed')) return;

  const state = getState(image);
  state.panning = true;
  state.moved = false;
  state.startX = event.clientX;
  state.startY = event.clientY;
  state.startTx = state.tx;
  state.startTy = state.ty;
  container.classList.add('is-panning');
  activePanImage = image;
  image.setPointerCapture?.(event.pointerId);
});

document.addEventListener('pointermove', (event) => {
  const image = activePanImage || event.target.closest('.image-magnify-click');
  if (!image) return;
  const state = getState(image);
  if (!state.panning) return;

  const bounds = getBounds(image);
  if (!bounds) return;
  const deltaX = event.clientX - state.startX;
  const deltaY = event.clientY - state.startY;
  if (Math.abs(deltaX) > DRAG_THRESHOLD || Math.abs(deltaY) > DRAG_THRESHOLD) {
    state.moved = true;
  }

  state.tx = clamp(state.startTx + deltaX, bounds.minX, bounds.maxX);
  state.ty = clamp(state.startTy + deltaY, bounds.minY, bounds.maxY);
  applyTransform(image);
});

function stopPan(event) {
  const image = activePanImage || event.target.closest('.image-magnify-click');
  if (!image) return;
  const container = image.closest('.product-media-container.media-type-image');
  if (!container) return;
  const state = getState(image);
  if (!state.panning) return;
  state.panning = false;
  state.movedRecently = state.moved;
  container.classList.remove('is-panning');
  activePanImage = null;
}

document.addEventListener('pointerup', stopPan);
document.addEventListener('pointercancel', stopPan);

document.querySelectorAll('media-gallery slider-component').forEach((sliderComponent) => {
  sliderComponent.addEventListener('slideChanged', () => {
    const galleryRoot = sliderComponent.closest('media-gallery');
    if (!galleryRoot) return;
    clearInlineZoom(galleryRoot);
  });
});
